import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ProductCard } from "./ProductCard";

function useCountdown(endDate) {
  const [remaining, setRemaining] = useState("");

  useEffect(() => {
    if (!endDate) return;
    const tick = () => {
      const diff = new Date(endDate).getTime() - Date.now();
      if (diff <= 0) {
        setRemaining("Expired");
        return;
      }
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      setRemaining(`${h}h ${m}m ${s}s`);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [endDate]);

  return remaining;
}

export function FlashDealsSection({ section }) {
  const products = section.products || [];
  const remaining = useCountdown(section.offer?.endDate);

  if (!products.length) return null;

  return (
    <section className="container mx-auto px-4 lg:px-8 py-8">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6">
        <div>
          <p className="text-xs sm:text-sm uppercase tracking-widest text-primary font-semibold mb-2">
            Flash Deals {remaining && `· Ends in ${remaining}`}
          </p>
          <h2 className="text-2xl sm:text-3xl font-display font-bold tracking-tight text-foreground">
            {section.title}
          </h2>
        </div>
        {section.viewAllLink && (
          <Link
            to={section.viewAllLink}
            className="text-sm font-semibold text-primary hover:underline shrink-0"
          >
            {section.viewAllLabel || "View All"}
          </Link>
        )}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-6">
        {products.map((p) => (
          <ProductCard key={p._id} p={p} variant="legacy" />
        ))}
      </div>
    </section>
  );
}
